import { CommonModule, DatePipe } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { AppRoutingModule } from '../app-routing.module';
import { BackButtonComponent } from './back-button/back-button.component';
import { DrawerCloseButtonComponent } from './drawer-close-button/drawer-close-button.component';
import { DistrictDescriptionOnlyPipe } from './pipes/district-description-only.pipe';
import { FormalDatePipe } from './pipes/formal-date.pipe';
import { ImageRefreshPipe } from './pipes/image-refresh.pipe';
import { OpenWeatherIconPipe } from './pipes/open-weather-icon.pipe';
import { OrdinalPipe } from './pipes/ordinal.pipe';
import { PhoneNumberPipe } from './pipes/phone-number.pipe';
import { StripHrefsPipe } from './pipes/strip-hrefs.pipe';
import { TimeOrStatusPipe } from './pipes/time-or-status.pipe';
import { TransitStatusPipe } from './pipes/transit-status.pipe';
import { TrustHtmlPipe } from './pipes/trust-html.pipe';
import { SpinnerComponent } from './spinner/spinner.component';
import { SvgIconComponent } from './svg-icon/svg-icon.component';
import { VideoComponent } from './video/video.component';
import { DirectionBtnCellRendererComponent } from './cell-renderers/direction-btn-cell-renderer/direction-btn-cell-renderer.component';

@NgModule({
  declarations: [
    OrdinalPipe,
    DistrictDescriptionOnlyPipe,
    TrustHtmlPipe,
    FormalDatePipe,
    TimeOrStatusPipe,
    TransitStatusPipe,
    OpenWeatherIconPipe,
    DrawerCloseButtonComponent,
    BackButtonComponent,
    SpinnerComponent,
    StripHrefsPipe,
    SvgIconComponent,
    VideoComponent,
    PhoneNumberPipe,
    ImageRefreshPipe,
    DirectionBtnCellRendererComponent
  ],
  providers: [
    DatePipe,
    OrdinalPipe
  ],
  imports: [
    CommonModule,
    AppRoutingModule,
    FontAwesomeModule
  ],
  exports: [
    FormsModule,
    DrawerCloseButtonComponent,
    BackButtonComponent,
    TrustHtmlPipe,
    FormalDatePipe,
    TimeOrStatusPipe,
    TransitStatusPipe,
    StripHrefsPipe,
    OpenWeatherIconPipe,
    SpinnerComponent,
    SvgIconComponent,
    DistrictDescriptionOnlyPipe,
    VideoComponent,
    PhoneNumberPipe,
    ImageRefreshPipe,
    DirectionBtnCellRendererComponent
  ]
})
export class SharedModule { }
